var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog-bottom",
      attrs: {
        title: "修改配送信息",
        visible: _vm.dvisible,
        width: "540px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dvisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formItem",
          attrs: {
            model: _vm.formItem,
            "label-width": "75px",
            rules: _vm.rules,
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _vm.dvisible
            ? _c("SendFrom", {
                attrs: { formItem: _vm.formItem, isShowBtn: false },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["platform:integral:order:invoice:update"],
                  expression: "['platform:integral:order:invoice:update']",
                },
              ],
              attrs: {
                loading: _vm.loadingBtn,
                size: "smalll",
                type: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.handleSubmit("formItem")
                },
              },
            },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }